import { getBestVoice } from "components/utils/voiceMap";
import { DashboardContext } from "contexts/DashboardContext";
import { useContext } from "react";
import { getCurrentDashboardProps } from "util/getCurrentDashboard";
import { findDashboardGroupById } from "util/dashboardGroups";

// Only works inside the WidgetContext provider currently
export const useTTS = () => {
  const { data } = useContext(DashboardContext);
  const activeGroup = findDashboardGroupById(data.dashboardGroups, data.activeDashboardGroupId);
  const props = getCurrentDashboardProps(data.activeDashboardId, activeGroup?.dashboards);
  // Warm the speech synthesis system up
  speechSynthesis.getVoices();

  const readAloud = (phrase: string) => {
    const selectedVoice = getBestVoice(props?.voiceType || "Female");
    speechSynthesis.cancel();

    if (selectedVoice) {
      const utterence = new SpeechSynthesisUtterance(phrase);
      utterence.voice = selectedVoice;

      speechSynthesis.speak(utterence);
    } else {
      speechSynthesis.speak(new SpeechSynthesisUtterance(phrase));
    }
  };

  return { readAloud };
};
